import React from 'react'
import { AuthLayoutProps } from './types'
import { AuthLayoutStyled } from './styles'
import Navbar from '../components/navbar/navbar'
import { isSomething } from '../utils/common-utils'
import NotificaionsWrapper from '../components/notification/notification-wrapper'
import { useAppSelector } from '../store/hooks'

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    const notifications = useAppSelector((state) => state.UI.notifications)

    return (
        <AuthLayoutStyled>
            <Navbar />
            {isSomething(notifications) && <NotificaionsWrapper />}
            {children}
        </AuthLayoutStyled>
    )
}

export default AuthLayout